// *******************************************************************************
// Blog-list filter
// *******************************************************************************
const blogListEle = document.querySelector('.blog-list');

if (blogListEle) {
  const sectionAnchor = blogListEle.getAttribute('id');
  const cmsSelectedCategories = blogListEle.getAttribute('data-cms-selected-category');
  const blogListInner = blogListEle.querySelector('.blog-list__row-inner');
  const taxonomyName = blogListEle.getAttribute('data-taxonomy');
  const postType = blogListEle.getAttribute('data-post-type');
  const simpleListing = blogListEle.getAttribute('data-simple-list');
  const blogListPagination = blogListEle.querySelector('.blog-list__footer');
  let allBtnValue = '';

  // toggle is-active
  const dataFilterLink = document.querySelectorAll('[data-filter-link]');
  const allFilterLink = document.querySelector('[data-filter-all]');

  attachEvent('[data-filter-link]', 'click', (ev) => {
    const allBtn = ev.target.getAttribute('data-filter-all');

    if (allBtn) {
      removeActiveClass(dataFilterLink);
      ev.target.classList.add('is-active');
    } else {
      ev.target.classList.toggle('is-active');
      const activeItems = document.querySelectorAll('[data-filter-link].is-active');
      allFilterLink.classList.toggle('is-active', activeItems.length === 0);
    }
  });

  attachEvent('.sc-blog-list .case-study-card__content a', 'click', (ev) => {
    const href = ev.target.getAttribute('href');
    if (href) {
      const params = new URLSearchParams(href);
      const refID = params.get('referenceID');
      if (refID) {
        ev.preventDefault();
        sendBlogListAjax('', '', refID);
      }
    }
  });

  const getActiveCategoryIds = (allActiveItems) =>
    Array.from(allActiveItems)
      .map((activeItem) => activeItem.getAttribute('data-category'))
      .join('|');

  const sendBlogListAjax = async (categoriesId, allBtnValue, refID) => {
    const ajaxData = new FormData();
    ajaxData.append('action', 'getFilteredBlogListPosts');
    ajaxData.append('id', localData.id);
    ajaxData.append('categoriesId', categoriesId);
    if (refID) {
      removeActiveClass(dataFilterLink);
      ajaxData.append('refId', refID);
    }
    ajaxData.append('postType', postType);
    ajaxData.append('taxonomyName', taxonomyName);
    ajaxData.append('simpleListing', simpleListing);
    ajaxData.append('allBtnValue', allBtnValue);
    ajaxData.append('sectionAnchor', sectionAnchor);
    try {
      const response = await axios.post(localData.siteURL, ajaxData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      window.history.replaceState(null, null, response.data.data.pageLink);
      blogListInner.innerHTML = response.data.data.posts;
      blogListPagination.innerHTML = response.data.data.pagination || '';

      blogListPagination.innerHTML = '';
      if (response.data.data.pagination) {
        blogListPagination.innerHTML = response.data.data.pagination;
      }
      document
        .querySelector('.blog-list')
        .classList.toggle(
          'blog-list--three-col',
          categoriesId.includes('references') || categoriesId.includes(localData.projectCategory),
        );
    } catch (error) {
      console.error(error);
    }
  };
  const blogAjax = (allElem) => {
    const allItems = blogListEle.querySelectorAll(allElem);
    const categoriesId = getActiveCategoryIds(allItems);
    allBtnValue = '';
    if (categoriesId === '') {
      allBtnValue = blogListEle.querySelector('[data-filter-all]').getAttribute('data-filter-all');
    }
    sendBlogListAjax(categoriesId || cmsSelectedCategories, allBtnValue);
  };

  attachEvent('.blog-list .blog-list__categories-link', 'click', () => {
    blogAjax('.blog-list__categories-link.is-active');
  });

  attachEvent('.blog-list .blog-list__tags-link', 'click', () => {
    blogAjax('.blog-list__tags-link.is-active');
  });

  attachEvent('.blog-list .secondary-nav__link', 'click', () => {
    blogAjax('.blog-list .secondary-nav__link.is-active');
  });
}

window.addEventListener('load', () => {
  // Check if the URL contains the section-anchor parameter
  const urlParams = new URLSearchParams(window.location.search);
  const sectionAnchor = urlParams.get('section-anchor');

  // Scroll to the specified anchor ID
  const targetElement = document.getElementById(sectionAnchor);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
  }
});
